(function () {
  "use strict";

  var MARKER_KEY = "tnd_apparel_pending";
  var TTL_MS = 2 * 60 * 60 * 1000;
  var checking = false;

  function clearMarker() {
    try {
      localStorage.removeItem(MARKER_KEY);
    } catch (error) {}
  }

  function readMarker() {
    var raw;

    try {
      raw = localStorage.getItem(MARKER_KEY);
    } catch (error) {
      return null;
    }

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (error) {
      clearMarker();
      return false;
    }
  }

  async function check() {
    var marker;
    var apparel;
    var spirits;

    if (checking) return;
    if (!window.TND || !window.TND.sources || !window.TND.launch || !window.TND.drawer) return;

    checking = true;

    try {
      marker = readMarker();
      if (!marker) return;
      if (Date.now() - marker.ts > TTL_MS) {
        clearMarker();
        return;
      }

      apparel = await Promise.resolve(window.TND.sources.readTnd());
      if (!(apparel && apparel.ok === true && apparel.count === 0)) return;

      spirits = await Promise.resolve(window.TND.sources.readSpirits());
      if (!(spirits && spirits.state === "OK" && spirits.gid)) {
        clearMarker();
        return;
      }

      if (spirits.gid !== marker.gid) {
        clearMarker();
        return;
      }

      if (window.TND.launch.statusFor(spirits.gid) === "LAUNCHED") {
        clearMarker();
        return;
      }

      clearMarker();
      if (typeof window.TND.drawer.markApparelPaid === "function") {
        window.TND.drawer.markApparelPaid();
      }
      window.TND.drawer.open();
    } finally {
      checking = false;
    }
  }

  window.addEventListener("pageshow", function () {
    check();
  });

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      check();
    }
  });

  if (document.readyState === "complete") {
    check();
  } else {
    window.addEventListener("load", function () {
      check();
    });
  }
})();
